import Vue from 'vue';
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import GdCheckbox from '@groovepages/gd-ui-kit/components/Checkbox';
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import GdDropdown from '@groovepages/gd-ui-kit/components/Dropdown';
import ExpansionPanel from '@groovepages/gd-ui-kit/components/ExpansionPanel';
import InfoPanel from '@groovepages/gd-ui-kit/components/InfoPanel';
import GdModal from '@groovepages/gd-ui-kit/components/Modal';
import GdSlider from '@groovepages/gd-ui-kit/components/Slider';
import DropMenu from '@groovepages/gd-ui-kit/components/DropMenu';
import GdToggle from '@groovepages/gd-ui-kit/components/Toggle';
import TextArea from '@groovepages/gd-ui-kit/components/TextArea';
import TextInput from '@groovepages/gd-ui-kit/components/TextInput';
import gdLoader from '@groovepages/gd-ui-kit/components/Loader';
import GdCustomRadio from './GdCustomRadio';
import NoHeadTextInput from './NoHeadTextInput';
import PasswordInput from './PasswordInput';
import FeatherIcon from './FeatherIcon';
import Child from './Child';
import GdCard from './GdCard';
import SidebarMenu from './SidebarMenu';
import CardLayout from './CardLayout';
import PricePoint from './PricePoint';
import CheckoutRadio from './CheckoutRadio';
import CheckoutPagePaymentOption from './CheckoutPagePaymentOption';
import HeaderBar from './HeaderBar';
import DropdownButton from './DropdownButton';
import CheckoutTemplateRadio from './CheckoutTemplateRadio';
import GdTabs from './GdTabs';

// Components that are registered globaly.
[
  Child,
  GdButton,
  GdCheckbox,
  ConfirmModal,
  FeatherIcon,
  GdDropdown,
  ExpansionPanel,
  InfoPanel,
  GdModal,
  GdSlider,
  HeaderBar,
  TextArea,
  TextInput,
  NoHeadTextInput,
  PasswordInput,
  GdToggle,
  GdCard,
  SidebarMenu,
  CardLayout,
  PricePoint,
  CheckoutRadio,
  CheckoutPagePaymentOption,
  DropMenu,
  DropdownButton,
  GdCustomRadio,
  GdTabs,
  CheckoutTemplateRadio,
  gdLoader,
].forEach(Component => {
  Vue.component(Component.name, Component);
});
